export default "__VITE_ASSET__DHxOUudv__"